import { createAction } from '@reduxjs/toolkit';

type ProductUrlType = NonNullable<string | null>;

interface ProductClickPayload {
  destinationUrl: ProductUrlType;
  productUrl: ProductUrlType;
  productCode: number;
  linkOpensInSameWindow: boolean;
}

export const productListClick = createAction<ProductClickPayload>('products/productListClick');
